import React, { useState } from "react";
import { supabase } from "../../supabaseClient"; // Prilagodi putanju ako treba

const AdminSettingsWeb = ({ onBack }) => {
  const [pin, setPin] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [pinError, setPinError] = useState(false);
  const [loading, setLoading] = useState(false);

  // Stanja za postavke weba
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [hideDataMode, setHideDataMode] = useState(false);
  const [badgeText, setBadgeText] = useState("");
  const [mainMessage, setMainMessage] = useState("");

  // Nova stanja za društvene mreže
  const [facebookUrl, setFacebookUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [tiktokUrl, setTiktokUrl] = useState("");

  const [saveSuccess, setSaveSuccess] = useState(false);

  // 1. Provjera PIN-a direktno iz prvog retka tablice i dohvaćanje svih podataka
  const handlePinSubmit = async (e) => {
    e.preventDefault();
    if (pin.length !== 4) return;
    setLoading(true);
    setPinError(false);

    try {
      const { data } = await supabase
        .from("site_settings")
        .select(
          "maintenance_pin, maintenance_mode, hide_data_mode, maintenance_badge, maintenance_message, facebook_url, instagram_url, tiktok_url",
        )
        .eq("id", 1)
        .single();

      if (data && data.maintenance_pin === pin) {
        setIsAuthorized(true);
        setIsMaintenance(data.maintenance_mode);
        setHideDataMode(data.hide_data_mode || false);
        setBadgeText(data.maintenance_badge || "");
        setMainMessage(data.maintenance_message || "");
        setFacebookUrl(data.facebook_url || "");
        setInstagramUrl(data.instagram_url || "");
        setTiktokUrl(data.tiktok_url || "");
      } else {
        setPinError(true);
        setPin("");
      }
    } catch {
      console.error("Greška prilikom provjere PIN-a s baze.");
    } finally {
      setLoading(false);
    }
  };

  // 2. Spremanje novih postavki i društvenih mreža u redak id: 1
  const handleSaveSettings = async () => {
    setLoading(true);
    setSaveSuccess(false);
    try {
      const { error } = await supabase
        .from("site_settings")
        .update({
          maintenance_mode: isMaintenance,
          hide_data_mode: hideDataMode,
          maintenance_message: mainMessage,
          maintenance_badge: badgeText,
          facebook_url: facebookUrl,
          instagram_url: instagramUrl,
          tiktok_url: tiktokUrl,
        })
        .eq("id", 1);

      if (!error) {
        setSaveSuccess(true);
        setTimeout(() => setSaveSuccess(false), 3000);
      }
    } catch {
      console.error("Greška prilikom spremanja postavki na bazu.");
    } finally {
      setLoading(false);
    }
  };

  // ZASLON ZA UPIS PIN-a
  if (!isAuthorized) {
    return (
      <div className="admin-settings-web-container">
        <div className="admin-back-btn" onClick={onBack}>
          <i className="fi fi-rs-angle-small-left"></i> Natrag
        </div>

        <div className="pin-auth-card">
          <i className="fi fi-rs-lock-laptop pin-icon"></i>
          <h4>Sigurnosna Provjera</h4>
          <p>Unesi 4-znamenkasti PIN za pristup kontroli weba.</p>

          <form onSubmit={handlePinSubmit}>
            <input
              type="password"
              maxLength="4"
              pattern="\d*"
              inputMode="numeric"
              placeholder="••••"
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
              disabled={loading}
              className={pinError ? "input-error" : ""}
              autoFocus
            />
            {pinError && (
              <span className="error-txt">Pogrešan PIN! Pokušaj ponovno.</span>
            )}

            <button type="submit" disabled={pin.length !== 4 || loading}>
              {loading ? "Provjera..." : "Potvrdi PIN"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // GLAVNI PANEL NAKON PROVJERE PIN-A
  return (
    <div className="admin-settings-web-container">
      <div className="admin-back-btn" onClick={onBack}>
        <i className="fi fi-rs-angle-small-left"></i> Natrag
      </div>

      <div className="web-control-panel">
        <div className="panel-header">
          <h3>
            <i className="fi fi-rs-settings-sliders"></i> Kontrola Statusa
            Stranice
          </h3>
          <p>
            Upravljaj vidljivošću weba, informacijama o održavanju i sportskim
            podacima.
          </p>
        </div>

        {/* PREKIDAČ: MAINTENANCE */}
        <div className="control-row toggle-row">
          <div className="control-info">
            <span>Zaključaj stranicu (U izradi)</span>
            <p>
              Kada je uključeno, korisnici će vidjeti samo poruku održavanja i
              društvene mreže, dok admin panel ostaje dostupan.
            </p>
          </div>
          <label className="switch-neon">
            <input
              type="checkbox"
              checked={isMaintenance}
              onChange={(e) => setIsMaintenance(e.target.checked)}
            />
            <span className="slider-neon"></span>
          </label>
        </div>

        {/* PREKIDAČ: SAKRIJ SPORTSKE PODATKE (Odvojen i uvijek vidljiv) */}
        <div
          className="control-row toggle-row"
          style={{
            marginTop: "15px",
            borderTop: "1px dashed rgba(255,255,255,0.05)",
            paddingTop: "15px",
          }}
        >
          <div className="control-info">
            <span>Sakrij sportske podatke</span>
            <p>
              Kada je uključeno, privremeno se skrivaju utakmice, rezultati
              uživo, raspored, grupe i strijelci na početnoj stranici.
            </p>
          </div>
          <label className="switch-neon">
            <input
              type="checkbox"
              checked={hideDataMode}
              onChange={(e) => setHideDataMode(e.target.checked)}
            />
            <span className="slider-neon"></span>
          </label>
        </div>

        {/* PODACI KOJI SE PRIKAZUJU SAMO AKO JE STRANICA POD MAINTENANCE MODE-OM */}
        {isMaintenance && (
          <div
            className="maintenance-fields-wrapper"
            style={{
              marginTop: "20px",
              borderTop: "1px solid rgba(255,255,255,0.1)",
              paddingTop: "10px",
            }}
          >
            {/* INPUT: GORNJI BADGE */}
            <div className="control-row">
              <label>Naziv Turnira / Gornji bedž</label>
              <input
                type="text"
                placeholder="Npr. MNT PODSUSED"
                value={badgeText}
                onChange={(e) => setBadgeText(e.target.value)}
              />
            </div>

            {/* INPUT: GLAVNA PORUKA */}
            <div className="control-row">
              <label>Glavna obavijest / Poruka turnira</label>
              <textarea
                rows="3"
                placeholder="Npr. VIDIMO SE NA TURNIRU OD 23.6 - 27.6"
                value={mainMessage}
                onChange={(e) => setMainMessage(e.target.value)}
              />
            </div>

            <div
              className="minimal-divider"
              style={{ margin: "20px 0", opacity: 0.1 }}
            ></div>

            {/* DRUŠTVENE MREŽE INPUTI */}
            <div className="panel-header" style={{ marginTop: "10px" }}>
              <h4>
                <i className="fi fi-rs-share"></i> Društvene Mreže
              </h4>
              <p>
                Ostavi prazno polje ako ne želiš da se ikonica te mreže
                prikazuje korisnicima na maintenance zaslonu.
              </p>
            </div>

            <div className="control-row">
              <label>
                <i className="fi fi-brands-facebook"></i> Facebook Link
              </label>
              <input
                type="url"
                placeholder="https://facebook.com/..."
                value={facebookUrl}
                onChange={(e) => setFacebookUrl(e.target.value)}
              />
            </div>

            <div className="control-row">
              <label>
                <i className="fi fi-brands-instagram"></i> Instagram Link
              </label>
              <input
                type="url"
                placeholder="https://instagram.com/..."
                value={instagramUrl}
                onChange={(e) => setInstagramUrl(e.target.value)}
              />
            </div>

            <div className="control-row">
              <label>
                <i className="fi fi-brands-tik-tok"></i> TikTok Link
              </label>
              <input
                type="url"
                placeholder="https://tiktok.com/@..."
                value={tiktokUrl}
                onChange={(e) => setTiktokUrl(e.target.value)}
              />
            </div>
          </div>
        )}

        {/* GUMB ZA SPREMANJE (Uvijek dostupan na dnu) */}
        <button
          className="save-settings-btn"
          onClick={handleSaveSettings}
          disabled={loading}
          style={{ marginTop: "30px" }}
        >
          {loading ? "Spremanje..." : "Spremi Postavke"}
        </button>

        {saveSuccess && (
          <div className="success-toast-neon">
            <i className="fi fi-rs-check-circle"></i> Postavke uspješno
            ažurirane!
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSettingsWeb;
